import { z } from 'zod';
/** Largest map side we will ever ship, in tiles. Bounds every coordinate on the wire. */
export const MAX_MAP_TILES = 1024;
export const TileCoordinateSchema = z
    .number()
    .int()
    .min(0)
    .max(MAX_MAP_TILES - 1);
/**
 * `move_to`: the player asks to walk to a tile. The server validates the path
 * step by step against the zone collision grid; the client never sends pixels.
 *
 * `from` is the tile the client's predicted walk turns on (ADR 0045). It is a
 * hint, never a position: the server only uses it if it lies on the path it
 * is already walking (`validateMoveFrom`).
 */
export const MoveToMessageSchema = z.object({
    x: TileCoordinateSchema,
    y: TileCoordinateSchema,
    from: z.object({ x: TileCoordinateSchema, y: TileCoordinateSchema }).optional(),
});
/**
 * `move_rejected`: the server refused a walk and says where the player really
 * stands, so a client that already started walking it (ADR 0045) goes back.
 */
export const MoveRejectedEventSchema = z.object({
    reason: z.string(),
    x: TileCoordinateSchema,
    y: TileCoordinateSchema,
});
//# sourceMappingURL=move-to.js.map